'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Thumb = function (_React$Component) {
    _inherits(Thumb, _React$Component);

    function Thumb() {
        _classCallCheck(this, Thumb);

        var _this = _possibleConstructorReturn(this, (Thumb.__proto__ || Object.getPrototypeOf(Thumb)).apply(this, arguments));

        _this.componentWillUnmount = function () {
            _this.removeDocumentMouseMoveListener();
            _this.removeDocumentMouseUpListener();
            _this.removeDocumentTouchEndListener();
            _this.removeDocumentTouchMoveListener();
        };
        /**
         * @return {Object} inline styles
         */
        _this.getStyle = function () {
            var percentage = _this.props.percentage;

            var perc = (percentage || 0) * 100;
            var style = {
                position: 'absolute',
                left: perc + '%'
            };
            return style;
        };
        _this.addDocumentMouseMoveListener = function () {
            _this.removeDocumentMouseMoveListener();
            _this.node.ownerDocument.addEventListener('mousemove', _this.handleMouseMove);
        };
        _this.addDocumentMouseUpListener = function () {
            _this.removeDocumentMouseUpListener();
            _this.node.ownerDocument.addEventListener('mouseup', _this.handleMouseUp);
        };
        _this.addDocumentTouchMoveListener = function () {
            _this.removeDocumentTouchMoveListener();
            _this.node.ownerDocument.addEventListener('touchmove', _this.handleTouchMove);
        };
        _this.addDocumentTouchEndListener = function () {
            _this.removeDocumentTouchEndListener();
            _this.node.ownerDocument.addEventListener('touchend', _this.handleTouchEnd);
        };
        _this.handleMouseDown = function () {
            var onDragStart = _this.props.onDragStart;

            onDragStart();
            _this.addDocumentMouseMoveListener();
            _this.addDocumentMouseUpListener();
        };
        _this.handleMouseUp = function () {
            _this.removeDocumentMouseMoveListener();
            _this.removeDocumentMouseUpListener();
        };
        _this.handleMouseMove = function (event) {
            var _this$props = _this.props,
                onThumbDrag = _this$props.onThumbDrag,
                type = _this$props.type;

            onThumbDrag(event, type);
        };
        _this.handleTouchStart = function () {
            var onDragStart = _this.props.onDragStart;

            onDragStart();
            _this.addDocumentTouchEndListener();
            _this.addDocumentTouchMoveListener();
        };
        _this.handleTouchMove = function (event) {
            var _this$props2 = _this.props,
                onThumbDrag = _this$props2.onThumbDrag,
                type = _this$props2.type;

            onThumbDrag(event, type);
        };
        _this.handleTouchEnd = function () {
            _this.removeDocumentTouchMoveListener();
            _this.removeDocumentTouchEndListener();
        };
        _this.handleKeyDown = function (event) {
            var _this$props3 = _this.props,
                onDragStart = _this$props3.onDragStart,
                onThumbKeyDown = _this$props3.onThumbKeyDown,
                type = _this$props3.type;

            onDragStart();
            onThumbKeyDown(event, type);
        };
        return _this;
    }

    _createClass(Thumb, [{
        key: 'removeDocumentTouchEndListener',
        value: function removeDocumentTouchEndListener() {
            this.node.ownerDocument.removeEventListener('touchend', this.handleTouchEnd);
        }
    }, {
        key: 'removeDocumentTouchMoveListener',
        value: function removeDocumentTouchMoveListener() {
            this.node.ownerDocument.removeEventListener('touchmove', this.handleTouchMove);
        }
    }, {
        key: 'removeDocumentMouseUpListener',
        value: function removeDocumentMouseUpListener() {
            this.node.ownerDocument.removeEventListener('mouseup', this.handleMouseUp);
        }
    }, {
        key: 'removeDocumentMouseMoveListener',
        value: function removeDocumentMouseMoveListener() {
            this.node.ownerDocument.removeEventListener('mousemove', this.handleMouseMove);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var style = this.getStyle();
            var _props = this.props,
                className = _props.className,
                ariaLabelledby = _props.ariaLabelledby,
                ariaControls = _props.ariaControls,
                maxValue = _props.maxValue,
                minValue = _props.minValue,
                value = _props.value,
                onDragEnd = _props.onDragEnd;

            return _react2.default.createElement("div", { className: className.thumbContainer, ref: function ref(node) {
                    _this2.node = node;
                }, style: style }, _react2.default.createElement("div", { "aria-labelledby": ariaLabelledby, "aria-controls": ariaControls, "aria-valuemax": maxValue, "aria-valuemin": minValue, "aria-valuenow": value, className: className.thumb, draggable: "false", onKeyDown: this.handleKeyDown, onMouseDown: this.handleMouseDown, onTouchStart: this.handleTouchStart, onKeyUp: onDragEnd, onMouseUp: onDragEnd, onTouchEnd: onDragEnd, onTouchCancel: onDragEnd, role: "slider", tabIndex: "0" }));
        }
    }]);

    return Thumb;
}(_react2.default.Component);

exports.default = Thumb;

Thumb.propTypes = {
    ariaLabelledby: _propTypes2.default.string.isRequired,
    ariaControls: _propTypes2.default.string.isRequired,
    className: _propTypes2.default.objectOf(_propTypes2.default.string).isRequired,
    maxValue: _propTypes2.default.number.isRequired,
    minValue: _propTypes2.default.number.isRequired,
    onThumbDrag: _propTypes2.default.func.isRequired,
    onThumbKeyDown: _propTypes2.default.func.isRequired,
    percentage: _propTypes2.default.number.isRequired,
    type: _propTypes2.default.string.isRequired,
    value: _propTypes2.default.number.isRequired,
    onDragStart: _propTypes2.default.func.isRequired,
    onDragEnd: _propTypes2.default.func.isRequired
};
//# sourceMappingURL=Thumb.js.map


// WEBPACK FOOTER //
// ./node_modules/luna-react/dist/components/Slider/Thumb.js